import { Tab, Tabs } from '@mui/material';
import classNames from 'classnames';
import { useLanguageContext } from 'context/LanguageProvider';

const LocaleSelector = ({ locales, currentLocale, className }) => {
  const { setLanguage } = useLanguageContext();

  if (!Array.isArray(locales) || locales.length === 0) {
    return undefined;
  }
  return (
    <div className={classNames('position-relative', className)}>
      <Tabs
        value={currentLocale?.id != null ? currentLocale.id : locales[0].id}
        slotProps={{ indicator: { sx: { display: 'none' } } }}
        sx={{ minHeight: 'auto' }}
      >
        {locales.map(({ id, name, code, localeLabel }) => (
          <Tab
            key={id}
            value={id}
            label={localeLabel ?? code}
            aria-label={name}
            disableRipple
            onClick={() => setLanguage(code)}
            sx={{
              minWidth: 'auto',
              minHeight: 'auto',
              px: 0,
              mr: '.5rem',
              '&:last-of-type': { mr: 0 },
              fontSize: 'inherit',
              fontWeight: 400,
              color: 'text.primary',
              opacity: 1,
              '&:hover': {
                color: 'primary.main',
                textDecoration: 'underline',
              },
              '&.Mui-selected': {
                color: 'primary.main',
                fontWeight: 600,
              },
            }}
          />
        ))}
      </Tabs>
    </div>
  );
};
export default LocaleSelector;
